import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Retreats } from './pages/Retreats';
import { Contact } from './pages/Contact';
import { Booking } from './pages/Booking';
import { LanguageProvider } from './components/LanguageContext';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2mm2j470bqezq">
      <Router data-id="element-1" data-mp="2mmvj8p4s268w">
        <ScrollToTop data-id="element-2" data-mp="2mndqegsza4vl" />
        <div className="min-h-screen bg-dark text-cream flex flex-col" data-id="element-3" data-mp="2mjpwvhnj9igv">
          <Navigation data-id="element-4" data-mp="31bi8bik7icdb" />
          <main className="flex-grow" data-id="element-5" data-mp="31ctfztgrw49p">
            <Routes data-id="element-6" data-mp="2wjgpfdsj9neb">
              <Route path="/" element={<Home data-id="element-8" data-mp="2wip54z4dzc3c" />} data-id="element-7" data-mp="2wiyuqllirh8i" />
              <Route path="/services" element={<Services data-id="element-10" data-mp="28tmg367fagyt" />} data-id="element-9" data-mp="28ufpkexrnkkn" />
              <Route path="/retreats" element={<Retreats data-id="element-12" data-mp="28s2z1ddy01vz" />} data-id="element-11" data-mp="28suw6sn6u7od" />
              <Route path="/contact" element={<Contact data-id="element-14" data-mp="23utcc5hxu4bu" />} data-id="element-13" data-mp="23vul23bheeqe" />
              <Route path="/booking" element={<Booking data-id="element-16" data-mp="3ikh7o8icgqyg" />} data-id="element-15" data-mp="23ti8y6semyl9" />
            </Routes>
          </main>
        </div>
      </Router>
    </LanguageProvider>;
}